

export default class VhUnit{

    constructor(){

        // Refresh vh height — fix
        // @source : https://css-tricks.com/the-trick-to-viewport-units-on-mobile/

        window.addEventListener('resize', () => {
            this.setUnit();
        });

        this.setUnit();
    }

    setUnit(){
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }


}



